var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.076,7.961a6.37,6.37,0,0,0-7.337-4.842C8.208,3.5,6.529,5.8,5.93,7.952c-2.507.505-4.156,2.461-3.9,4.727a4.667,4.667,0,0,0,4.641,4.139h.007a.75.75,0,0,0,0-1.5H6.675a3.169,3.169,0,0,1-3.151-2.81c-.205-1.79,1.446-2.958,3.1-3.149L7.169,9.3l.107-.535C7.647,6.916,9.033,4.894,10.964,4.6a4.927,4.927,0,0,1,5.76,4.164l.107.532.538.065c1.5.184,3.113,1.126,3.124,2.765a3.174,3.174,0,0,1-3.151,3.191.75.75,0,0,0,.005,1.5h0a4.671,4.671,0,0,0,4.642-4.7C21.978,9.781,20.04,8.377,18.076,7.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.878,7.973,12.905a.75.75,0,0,0,1.06,1.061l2.217-2.217v8.469a.75.75,0,1,0,1.5,0V11.749l2.217,2.217a.75.75,0,0,0,1.06-1.061Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSimple);
export default __webpack_public_path__ + "static/media/upload_simple.951f8e0201129c2c916a695194fd1f79.svg";
export { ForwardRef as ReactComponent };